import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

// AUTH TOKEN START
import jwt_decode from 'jwt-decode'
import { ls } from 'utils'
import { LSKEY_TOKEN } from 'constants/app'
// AUTH TOKEN END

import { purchaseRedemptionReversal } from 'api/purchase'
import { MerchantLookupTypes } from 'types/merchanTxTypes'
import {
  PurchaseRedemptionReversalTxFormTypes,
  PurchaseRedemptionReversalTxFormSubmitValuesTypes,
  PurchaseRedemptionReversalTxFormSubmitActionsTypes,
} from 'types/purchaseReversalTxTypes'
import { MemberDetail } from 'types/member'
import useMemberStore from 'store/member'

const PURCHASEREDEMPTIONTXINITVAL: PurchaseRedemptionReversalTxFormTypes = {
  externalTransactionId: '',
  ident: '',
  storeId: 0,
  cashier: '',
  comments: '',
  traceNumber: 0,
  reasonId: 0,
}

export const usePurchaseRedmptionReversalTx = (
  traderId: number,
  onCloseModal: () => void
): {
  member: MemberDetail | undefined
  isLoading: boolean
  initialValues: PurchaseRedemptionReversalTxFormTypes
  isMerchantLookupToggle: boolean
  handleIsMerchantLookupToggle: () => void
  handleSubmitPurchaseRedemptionReversalTx: (
    values: PurchaseRedemptionReversalTxFormSubmitValuesTypes,
    actions: PurchaseRedemptionReversalTxFormSubmitActionsTypes
  ) => void
  handleClearPurchaseRedemptionReversalTx: () => void
} => {
  // AUTH TOKEN START
  const authToken = ls.get(LSKEY_TOKEN)
  const decodeAuthToken: { username: string } = jwt_decode(String(authToken))
  const authTokenUsername = decodeAuthToken?.username || ''
  // AUTH TOKEN END
  // STATES
  const [isMerchantLookupToggle, isMerchantLookupToggleSet] =
    useState<boolean>(false)
  const [isLoading, isLoadingSet] = useState<boolean>(false)
  const [purchaseTxMerchant, purchaseTxMerchantSet] = useState<
    MerchantLookupTypes[]
  >([])
  const member = useMemberStore((state) => state.member)
  const [initialValues, initialValuesSet] =
    useState<PurchaseRedemptionReversalTxFormTypes>({
      ...PURCHASEREDEMPTIONTXINITVAL,
      cashier: authTokenUsername,
      externalTransactionId: '',
      ident: String(member?.cardNumber) || '',
    })

  const handleIsMerchantLookupToggle = useCallback(() => {
    isMerchantLookupToggleSet(!isMerchantLookupToggle)
  }, [isMerchantLookupToggle, isMerchantLookupToggleSet])

  const handleSubmitPurchaseRedemptionReversalTx = useCallback(
    async (
      values: PurchaseRedemptionReversalTxFormSubmitValuesTypes,
      actions: PurchaseRedemptionReversalTxFormSubmitActionsTypes
    ) => {
      isLoadingSet(true)
      try {
        await purchaseRedemptionReversal(values)
        toast.success('Purchase/Loyalty redemption reversal successful.')
        // actions.setSubmitting(false)
        onCloseModal()
      } catch (error) {
        const message = JSON.parse(JSON.stringify(error))
        toast.error(`ERR: ${message.outcomeUserMessage}`)
      }
      isLoadingSet(false)
    },
    [isLoadingSet]
  )

  const handleClearPurchaseRedemptionReversalTx = useCallback(() => {
    initialValuesSet({ ...PURCHASEREDEMPTIONTXINITVAL })
    toast.success('Filter successfully cleared.')
  }, [initialValuesSet])

  return {
    member,
    isLoading,
    initialValues,
    isMerchantLookupToggle,
    handleIsMerchantLookupToggle,
    handleSubmitPurchaseRedemptionReversalTx,
    handleClearPurchaseRedemptionReversalTx,
  }
}
